import numeral from 'numeral'

const NumeralFormat = {
    Integer: '0,0',
    Decimal: '0,0.00',
}

export function formatToCurrency(value) {
    return Number.isInteger(value)
        ? `R ${convertToFormat(value, NumeralFormat.Integer).replace(/,/g, ' ')}`
        : `R ${convertToFormat(value, NumeralFormat.Decimal).replace(/,/g, ' ')}`
}

function convertToFormat(value, format) {
    return numeral(value).format(format)
}
